/**
 * Determines if a graduation year is editable based on the current school year.
 * For current launch (SY 2025-2026): allow 2024-2025 and 2023-2024
 * Otherwise: only allow current school year (original logic)
 *
 * @param schoolYear - The graduation year to check
 * @param currentSchoolYear - The current school year
 * @returns true if the graduation year is editable, false otherwise
 */
export const isEditableSchoolYear = (
  schoolYear: string | undefined,
  currentSchoolYear: string | null
): boolean => {
  if (!schoolYear || !currentSchoolYear) {
    return false;
  }
  if (schoolYear === currentSchoolYear) {
    return true;
  }
  return false;
};
